

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IWikiType } from "@/@types/wiki/wiki_types";
import { IWikiCategory } from "@/@types/wiki/wiki-object";
import { deleteElement } from "@/api/delite/delite-element";
import { dangisWiki as wiki } from "@/config/host.config";

import WikiCategoryList from "@/components/tables/wiki/wiki-category-list.vue";
import WikiCategoryDescription from "./wiki-category-description.vue";
import WikiCategoryForm from "./wiki-category-form.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    WikiCategoryList,
    WikiCategoryDescription,
    WikiCategoryForm,
  },
})
export default class AddWikiCategoryModal extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiCategory>;

  category_id = "";
  deleted = false;

  get category(): IWikiCategory | null {
    const cat = this.categorys.find((el) => el._id == this.category_id);
    return cat ? cat : null;
  }

  get mainCategorys(): Array<IWikiCategory> {
    return this.categorys.filter((c) => {
      if (c.type == IWikiType.main) return c;
    });
  }

  get subCategorys(): Array<IWikiCategory> {
    return this.categorys.filter((c) => {
      if (c.type == IWikiType.sub) return c;
    });
  }

  openCatDescription(id: string): void {
    this.category_id = id;
    this.$nextTick(() =>
      setTimeout(() => this.$bvModal.show("wiki-category-description"), 0)
    );
  }

  changecategory(id: string): void {
    this.category_id = id;
    this.$nextTick(() =>
      setTimeout(() => this.$bvModal.show("wiki-category-form"), 0)
    );
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  async deletecategory(id: string): Promise<void> {
    const uri = this.deleted ? wiki.categorys.force : wiki.categorys.main;

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("Category.delete")),
        }
      );

      if (result === true) {
        deleteElement(id, uri)
          .then(() => this.onSuccess())
          .catch(() => this.onError());
      }
    } catch {
      this.onError();
    }
  }

  async updateCat(data: Partial<IWikiCategory>, id: string): Promise<void> {
    let uri = wiki.categorys.main;
    const idcat = id ? id : this.category_id;
    if (idcat) uri += `/${idcat}`;
    const method = idcat ? "put" : "post";

    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.$emit("updatecatlist", idcat, res.data);
        this.$nextTick(() => (this.category_id = ""));
        this.onSuccess();
        this.$bvModal.hide("wiki-category-form");
        this.category_id = "";
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }
}
